import React from 'react';
import './portfolio.css';
import IMGP from '../../assets/image.png';
import IMGFW from '../../assets/fw.png';
import IMG0 from '../../assets/portfolio0.jpg';
import IMG1 from '../../assets/portfolio1.jpg';
import IMG2 from '../../assets/portfolio2.jpg';
import IMG3 from '../../assets/portfolio3.jpg';
import IMG4 from '../../assets/portfolio4.jpg';
import IMG5 from '../../assets/Smile.jpeg';
import IMG6 from '../../assets/chatapp.png';
import IMGCLIENT2 from '../../assets/client2.jpg';
import IMGFLYESIM from '../../assets/flyesimclient.png'; // Import FlyeSim image

// Import React Icons
import { FaApple, FaGooglePlay } from 'react-icons/fa';

const data = [
  // Boneless 28 (Moved to top)
  {
    id: 8,
    image: IMGCLIENT2,
    title: 'Boneless 28',
    description: 'Developed the mobile app for Lebanese restaurant BonelessS28, featuring online ordering, tracking, and loyalty programs. (Note: App stores list the account owner, Rodrigues, not the developer.)',
    github: '',
    demo: '',
    appleStoreLink: 'https://apps.apple.com/lb/app/boneless/id6740768289',
    googlePlayLink: 'https://play.google.com/store/apps/details?id=com.muhammedseyhmusa.boneless28',
  },
  // FlyeSim (Added)
  {
    id: 9,
    image: IMGFLYESIM,
    title: 'FlyeSim',
    description: "User-friendly website for Flyesim, an eSIM solutions provider for global travel, featuring product info and online purchasing.",
    github: '',
    demo: 'https://www.flyesim.net',
  },
  // Reflect-Mena (Moved up)
  {
    id: 1,
    image: IMGFW,
    title: 'Reflect-Mena',
    description: 'As a co-founder, I designed and developed a sleek, professional, and informative website for Reflect Mena, effectively showcasing their diverse range of services and extensive portfolio to potential clients.',
    github: '',
    demo: 'https://reflectmena.com/',
  },
  // Future Restaurant (Moved down)
  {
    id: 0,
    image: IMGP,
    title: 'Future Restaurant',
    description: 'Developed a modern, interactive website concept for a futuristic restaurant. Features online ordering integration, dynamic menus, and table reservation capabilities.',
    github: 'https://github.com/MuhammedSm/restaurant',
    demo: 'https://futurerestaurant.netlify.app/',
  },
  // React-Portfolio-Website
  {
    id: 2,
    image: IMG0,
    title: 'React-Portfolio-Website',
    description: 'A personal portfolio website meticulously built using React.js to dynamically showcase completed projects, technical skills, and professional experience to potential employers or clients.',
    github: 'https://github.com/MuhammedSm/Portfolio-react-website',
    demo: 'https://your-portfolio-website-demo-url.com',
  },
  // Muhammed Chat
  {
    id: 3,
    image: IMG6,
    title: 'Muhammed Chat (Web Chat App)',
    description: 'Developed a real-time web chat application leveraging React for the frontend and Firebase for backend services, enabling instant messaging between users.',
    github: 'https://github.com/MuhammedSm/React-chat-app',
    demo: 'https://muhammesdseyhmusachatapp.netlify.app',
  },
  // Smile!
  {
    id: 4,
    image: IMG5,
    title: 'Smile! (Attendance Taking System Using Facial Recognition)',
    description: 'A comprehensive senior project implementing facial recognition technology for an automated attendance tracking system, improving efficiency and accuracy.',
    github: 'https://github.com/MuhammedSm/senior-project-Smile---',
    demo: '',
  },
  // Personal-Voice-Assistant-Java
  {
    id: 5,
    image: IMG1,
    title: 'Personal-Voice-Assistant-Java',
    description: 'A Java-based personal voice assistant application capable of understanding and executing various tasks through voice commands, demonstrating OOP principles.',
    github: 'https://github.com/MuhammedSm/Personal-Voice-Assistant-Java',
    demo: '',
  },
  // Vaccination-Clinic-System-Java
  {
    id: 6,
    image: IMG2,
    title: 'Vaccination-Clinic-System-Java',
    description: 'Designed and implemented a system in Java to manage vaccination clinic operations, including patient registration, appointment scheduling, and inventory records.',
    github: 'https://github.com/MuhammedSm/Vaccination-Clinic-System',
    demo: '',
  },
  // Movie Rating DataBase Website
  {
    id: 7,
    image: IMG3,
    title: 'Movie Rating DataBase Website',
    description: 'Created a dynamic web application allowing users to browse an extensive movie database, submit ratings, write reviews, and discover new films through interaction.',
    github: 'https://github.com/MuhammedSm/movie-rating-db',
    demo: '',
  },
];

function Portfolio() {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {data.map(({ id, image, title, description, github, demo, appleStoreLink, googlePlayLink }) => {
          return (
            <article 
              key={id} 
              className="portfolio__item" 
              data-aos="fade-up" 
              data-aos-delay={(id % 3) * 100}
            >
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <div className="portfolio__item-content">
                <h3>{title}</h3>
                <p className="portfolio__item-description">{description}</p>
              </div>
              <div className="portfolio__item-cta">
                {github && [3, 5, 6].includes(id) && (
                  <a 
                    href={github} 
                    className={`btn ${github && [3, 5, 6].includes(id) && !demo ? 'btn-full-width' : ''}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Github
                  </a>
                )}
                {demo && (
                  <a 
                    href={demo} 
                    className={`btn btn-primary ${demo && (!github || ![3, 5, 6].includes(id)) ? 'btn-full-width' : ''}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Visit Website
                  </a>
                )}
              </div>
              {(appleStoreLink || googlePlayLink) && (
                <div className="portfolio__item-app-stores">
                  {appleStoreLink && (
                    <a 
                      href={appleStoreLink} 
                      className={`btn btn-appstore ${appleStoreLink && !googlePlayLink ? 'btn-full-width' : ''}`}
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <FaApple /> App Store
                    </a>
                  )}
                  {googlePlayLink && (
                    <a 
                      href={googlePlayLink} 
                      className={`btn btn-googleplay ${googlePlayLink && !appleStoreLink ? 'btn-full-width' : ''}`}
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <FaGooglePlay /> Google Play
                    </a>
                  )}
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Portfolio;
